/* Preserve Privy's forms, event handlers, audience rules and coupon flow. */
(() => {
  'use strict';
  const imageUrl = 'https://cdn.shopify.com/s/files/1/0486/2800/7062/files/oddityrc-echo5-newsletter.jpg?v=1793759644&width=1000';
  const oldImage = '0f9b3e237f5c40b0a32fb5f485e0cf07';
  const selector = '.privy-widget-popup, [aria-label="Marketing and promotions tab left"]';
  function brand(element) {
    if (element.matches('.privy-widget-popup')) {
      element.querySelectorAll('.privy-widget-image img').forEach((img) => {
        if (img.dataset.oddEcho5Photo) return;
        if (!img.src.includes(oldImage) && img.alt !== '25pro0023.JPG') return;
        img.dataset.oddEcho5Photo = 'true';
        img.removeAttribute('srcset');
        img.src = imageUrl;
        img.alt = 'OddityRC ECHO5 frame with green protective parts, photographed on rock';
        img.decoding = 'async';
      });
    } else {
      element.querySelectorAll('button, [role="button"]').forEach((button) => {
        if (button.textContent.trim() === 'Get 8% Off!') button.classList.add('odd-newsletter-tab');
      });
    }
  }
  function inspect(root) {
    if (root.nodeType !== 1) return;
    if (root.matches(selector)) brand(root);
    root.querySelectorAll(selector).forEach(brand);
    const popup = root.closest('.privy-widget-popup');
    if (popup) brand(popup);
  }
  document.querySelectorAll(selector).forEach(brand);
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach(inspect));
  }).observe(document.body, { childList: true, subtree: true });
})();